import { useEffect } from "react";
import { useScrollReveal } from "@/hooks/useScrollReveal";
import Navbar from "@/pages/home/components/Navbar";
import Footer from "@/pages/home/components/Footer";
import WhatsAppFloat from "@/pages/home/components/WhatsAppFloat";
import VentilacionHero from "./components/VentilacionHero";
import VentilacionIntro from "./components/VentilacionIntro";
import VentilacionServices from "./components/VentilacionServices";
import VentilacionProcess from "./components/VentilacionProcess";
import VentilacionBenefits from "./components/VentilacionBenefits";
import VentilacionSectors from "./components/VentilacionSectors";
import VentilacionCta from "./components/VentilacionCta";

export default function VentilacionMecanica() {
  useScrollReveal();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background-50 font-body text-foreground-900">
      <Navbar />
      <main>
        <VentilacionHero />
        <VentilacionIntro />
        <VentilacionServices />
        <VentilacionProcess />
        <VentilacionBenefits />
        <VentilacionSectors />
        <VentilacionCta />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}